import { Container, Row } from 'reactstrap'
import { Typography, UIKits } from '../../../constants'
import FontWeight from "./FontWeight";
import DisplayHeading from './DisplayHeadings';
import InlineTextElements from "./InlineTextElements";
import TextColor from "./TextColor";
import BlockQuotesCard from "./BlockQuotes";
import Breadcrumbs from '../../../coreComponents/breadcrumbs';
import Headings from './headings';
import ColoredHeadings from './coloredHeadings';
import Listing from './listing';

const TypographyContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Typography} parent={UIKits} />
      <Container fluid>
        <Row>
          <Headings />
          <ColoredHeadings />
          <FontWeight />
          <Listing />
          <DisplayHeading />
          <InlineTextElements />
          <TextColor />
          <BlockQuotesCard />
        </Row>
      </Container>
    </>
  )
}

export default TypographyContainer